package com.appsyde.shared.presentation.style.style

import com.appsyde.shared.presentation.style.token.AppStylesTokens
import org.jetbrains.compose.web.css.*

object AppStylesCards : StyleSheet() {

    /**
     * Only keep perf hints here.
     * NOTE: Do NOT set `transition` here, because `pageCardGlass` also sets `transition`
     * and CSS transition is NOT additive (one wins and overwrites the other).
     */
    val ticketCardAnimated by style {
        property("will-change", "transform, opacity")
    }

    /** Baseline (Idle) state for the animated card */
    val ticketCardIdle by style {
        property("transform", "translateY(0px)")
        opacity(1)
    }

    val ticketCardExit by style {
        property("transform", "translateY(-12px)")
        opacity(0)
    }

    val ticketCardEnter by style {
        property("transform", "translateY(12px)")
        opacity(0)
    }

    val ticketCardExitBack by style {
        property("transform", "translateY(12px)")
        opacity(0)
    }

    val ticketCardEnterBack by style {
        property("transform", "translateY(-12px)")
        opacity(0)
    }

    val pageCardGlass by style {
        backgroundColor(Color(AppStylesTokens.CARD))
        borderRadius(AppStylesTokens.RADIUS_PAGE.px)
        property("border", "1px solid ${AppStylesTokens.BORDER}")
        property("box-shadow", AppStylesTokens.SHADOW_PAGE_CARD)

        // ✅ FIX: transition must include BOTH hover shadow and the ticket animation props
        // because CSS `transition` is not additive (the last applied rule wins).
        property(
            "transition",
            "box-shadow 160ms ease, transform 150ms ease-out, opacity 150ms ease-out"
        )

        self + hover style {
            property("box-shadow", "0 24px 62px rgba(15,23,42,0.06), 0 6px 18px rgba(102,96,230,0.03)")
        }

        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Column)
        minHeight(0.px)

        property("max-height", "calc(100vh - 120px)")
        minHeight(0.px)
        property("scrollbar-width", "thin")
        property("scrollbar-color", "rgba(15,23,42,0.18) transparent")
        overflow("hidden")
        position(Position.Relative)
    }

    val pageCardBody by style {
        paddingTop(28.px)
        paddingBottom(16.px)
        paddingLeft(40.px)
        paddingRight(40.px)

        property("scrollbar-width", "thin")
        property("scrollbar-color", "rgba(15,23,42,0.18) transparent")

        overflowY("auto")
        property("overscroll-behavior", "contain")
        property("overflow-anchor", "none")

        property("flex", "1")
        minHeight(0.px)

        minWidth(0.px)
    }

    /** Fond du corps de la page card (header blanc + corps teinté). À combiner avec pageCardBody. */
    val pageCardBodyBg by style {
        backgroundColor(Color(AppStylesTokens.CARD_BODY_BG))
    }

    val ticketCardGlass by style {
        backgroundColor(Color(AppStylesTokens.CARD))
        borderRadius(AppStylesTokens.RADIUS_CARD.px)
        padding(16.px)
        property("border", "1px solid rgba(15, 23, 42, 0.06)")
        property("box-shadow", AppStylesTokens.SHADOW_CARD)
    }

    val ticketCardHeader by style {
        position(Position.Sticky)
        top(0.px)
        property("z-index", "5")

        padding(14.px, 26.px)
        display(DisplayStyle.Flex)
        justifyContent(JustifyContent.SpaceBetween)
        alignItems(AlignItems.Center)

        backgroundColor(rgba(255, 255, 255, 0.86))
        property("backdrop-filter", "blur(10px)")
        property("border-bottom", "1px solid ${rgba(0, 0, 0, 0.06)}")
        property("border-top-left-radius", "${AppStylesTokens.RADIUS_PAGE}px")
        property("border-top-right-radius", "${AppStylesTokens.RADIUS_PAGE}px")
    }
}
